import { combineReducers } from "redux";
import globalReducer from "Store/global/reducers";
import instructorReducer from "Store/instructors/reducers";
import studentReducer from "Store/students/reducers";
import classesReducer from "Store/classrooms/reducers";
import userReducer from "Store/user/reducers";
import locationReducer from "Store/locations/reducers";
import courseTemplatesReducer from "Store/courseTemplates/reducers";
import calendarReducer from "Store/calendar/reducers";
import backgroundTasksReducer from "Store/backgroundTasks/reducers";

const appReducer = combineReducers({
  instructorReducer,
  studentReducer,
  classesReducer,
  userReducer,
  locationReducer,
  courseTemplatesReducer,
  globalReducer,
  calendarReducer,
  backgroundTasksReducer
});

const rootReducers = (state, action) => {
  if (action.type === "SET_CURRENT_USER" && action.user === null) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducers;
